import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

// Devuelve las habitaciones activas con su galería pública.
// Como el bucket es privado, generamos signed URLs de 1 hora.
export const listHabitacionesConFotos = createServerFn({ method: "GET" }).handler(async () => {
  const supabase = createClient<Database>(
    process.env.SUPABASE_URL!,
    process.env.SUPABASE_PUBLISHABLE_KEY!,
    { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
  );

  const { data: habs, error } = await supabase
    .from("habitaciones")
    .select("id, nombre, descripcion, capacidad, orden, activa, precio_temporada_baja")
    .eq("activa", true)
    .order("orden", { ascending: true });
  if (error) throw new Error(error.message);

  const ids = (habs ?? []).map((h) => h.id);
  if (ids.length === 0) return [];

  const { data: fotos, error: fErr } = await supabase
    .from("habitacion_fotos")
    .select("habitacion_id, storage_path, alt, orden")
    .in("habitacion_id", ids)
    .order("orden", { ascending: true });
  if (fErr) throw new Error(fErr.message);

  const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
  const result = await Promise.all(
    (habs ?? []).map(async (h) => {
      const fs = (fotos ?? []).filter((f) => f.habitacion_id === h.id);
      const signed = await Promise.all(
        fs.map(async (f) => {
          const { data } = await supabaseAdmin.storage
            .from("habitaciones")
            .createSignedUrl(f.storage_path, 60 * 60);
          return { url: data?.signedUrl ?? "", alt: f.alt ?? h.nombre };
        }),
      );
      return {
        id: h.id,
        nombre: h.nombre,
        descripcion: h.descripcion ?? "",
        capacidad: h.capacidad,
        precioDesde:
          h.precio_temporada_baja != null && Number(h.precio_temporada_baja) > 0
            ? Math.round(Number(h.precio_temporada_baja))
            : null,
        fotos: signed.filter((s) => s.url),
      };
    }),
  );
  return result;
});